var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 mx-5 my-sm-15 mx-sm-10"},[_c('v-row',[_c('v-col',[_c('AvailableQuizzes')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }